module.exports = __webpack_public_path__ + "static/media/clear_chart.2515c0af.png";